export const isMobile = () => {
  const userAgent = navigator.userAgent;
  return /android|iphone|ipad|ipod|Android/i.test(userAgent);
};
